import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import BaseLayout from "@/Layouts/BaseLayout";
import {Breadcrumbs} from '@mui/material';
import {ScrollMenu} from 'react-horizontal-scrolling-menu';
import QualityGuaranteeSlider from "@/Pages/GualityQuarantee/QualityGuaranteeSlider";
import Link from "@/Layouts/Link";
import {isMobile} from "@/Helpers/Function";
import '@/Pages/GualityQuarantee/scss/index.scss';

class GualityQuarantee extends React.Component {
    render() {
        let {mobileApp = false} = this.props;

        const data = chips.map((el) => {
            return <div key={el.id}
                        className={`guarantee-chip guarantee-chip__${el.id}`}>
                <p className={`guarantee-chip__top`}>{el.year}</p>
                <p className={`guarantee-chip__bottom`}>{el.text}</p>
            </div>
        });

        return <BaseLayout {...this.props}>
            <section className={`section`}>
                {!mobileApp && (
                    <div className={`breadcrumbs`}>
                        <div className="container">
                            <Breadcrumbs
                                maxItems={2}
                                itemsAfterCollapse={2}
                            >
                                <Link className="breadcrumbs__link" href={`/`}>
                                    Главная
                                </Link>
                                <p className="breadcrumbs__text">
                                    Гарантии качества
                                </p>
                            </Breadcrumbs>
                        </div>
                    </div>
                )}
                <div className={`container`}>
                    <h1 className={`h1`}>Гарантии качества</h1>
                </div>
                <div className={`guarantee`}>
                    <div className={`guarantee__bgColorGray`}>
                        <div className={`container`}>
                            <div className={`guarantee-main`}>
                                <div className={`guarantee-main__content`}>
                                    <p className={`guarantee-main__title`}>
                                        Мы по праву можем гордиться высоким качеством наших украшений!
                                    </p>
                                    <p className={`guarantee-main__text`}>
                                        Чтобы добиться такого результата, мы используем банковские драгоценные
                                        металлы, высококачественные лигатурные сплавы, современное
                                        высокотехнологичное оборудование, применяем
                                        сертифицированные натуральные вставки, проводим многоступенчатый контроль
                                        технологического процесса и качества сырья.
                                    </p>
                                </div>
                                <div className={`guarantee-main__image`}>
                                    <picture>
                                        <source type={`image/webp`}
                                                srcSet={`/storage/img/quality-guarantee/banner.webp`}
                                        />
                                        <img src={`/storage/img/quality-guarantee/banner.png`}
                                             alt={`banner`}
                                             title={`banner`}
                                        />
                                    </picture>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`container`}>
                        <p className={`guarantee-title`}>
                            Уникальный Идентификационный Номер
                        </p>
                        <div className={`guarantee-uin`}>
                            <div className={`guarantee-uin__image`}>
                                <picture>
                                    <source type={`image/webp`}
                                            srcSet={`/storage/img/quality-guarantee/uin.webp`}
                                    />
                                    <img src={`/storage/img/quality-guarantee/uin.png`}
                                         alt={`uin`}
                                         title={`uin`}
                                         loading={`lazy`}
                                    />
                                </picture>
                            </div>
                            <div className={`guarantee-uin__content`}>
                                <p className={`guarantee-uin__text`}>
                                    Подтверждением легальности происхождения драгоценного металла и драгоценных
                                    камней служит <span className={`bold`}>Уникальный Идентификационный Номер
                                        (УИН) - 16-тизначный код,</span> нанесенный на бирку ювелирного изделия. Каждое
                                    украшение проходит регистрацию в Государственной Интегрированной Информационной
                                    Системе в сфере контроля за оборотом драгоценных металлов и драгоценных камней
                                    (ГИИС ДМДК), где ему и присваивается УИН.
                                </p>
                            </div>
                            <p className={`guarantee-uin__text`}>
                                <span className={`bold`}>Проверьте Ваше украшение на сайте </span>
                                <a href={`https://probpalata.gov.ru`} target={`_blank`} className={`link`}>
                                    https://probpalata.gov.ru
                                </a>
                            </p>
                            <p className={`guarantee-uin__text`}>
                                Вы сможете увидеть подробную информацию о производителе,
                                характеристиках изделия, драгоценном металле, из которого оно изготовлено, и
                                драгоценных камнях.
                            </p>
                        </div>
                    </div>
                    <div className={`guarantee__bgColorGray`}>
                        <div className={`container`}>
                            <p className={`guarantee-title`}>
                                Именник
                            </p>
                            <div className={`guarantee-namesake`}>
                                <div className={`guarantee-namesake__content`}>
                                    <p className={`guarantee-namesake__text`}>
                                        На каждом украшении ювелирного бренда PLATINA присутствует <span
                                        className={`bold`}>
                                                именник - клеймо, ежегодно присваиваемое предприятию-изготовителю
                                                Верхне-Волжским межрегиональным управлением Федеральной пробирной
                                                палаты.
                                            </span>
                                    </p>
                                </div>
                                <div className={`guarantee-namesake__image`}>
                                    <picture>
                                        <source type={`image/webp`}
                                                srcSet={`/storage/img/quality-guarantee/namesake.webp`}
                                        />
                                        <img src={`/storage/img/quality-guarantee/namesake.png`}
                                             alt={`namesake`}
                                             title={`namesake`}
                                             loading={`lazy`}
                                        />
                                    </picture>
                                </div>
                                <div className={`guarantee-namesake__list`}>
                                    <p className={`guarantee-namesake__text`}>
                                        Наш именник состоит из:
                                    </p>
                                    <p>&nbsp;</p>
                                    <div className={`item`}>
                                        <div className={`circle`}>1</div>
                                        <p className={`text`}>код года выпуска</p>
                                    </div>
                                    <div className={`item`}>
                                        <div className={`circle`}>2</div>
                                        <p className={`text`}>код межрегионального управления Федеральной пробирной
                                            палаты</p>
                                    </div>
                                    <div className={`item`}>
                                        <div className={`circle`}>3</div>
                                        <p className={`text`}>код изготовителя</p>
                                    </div>
                                </div>
                                <p className={`guarantee-namesake__text`}>
                                    Наши именники:
                                </p>
                                <div className={`guarantee__table`}>
                                    {/*<div className={`guarantee__table_wrapper`}>*/}
                                    <ScrollMenu
                                        alignCenter={false}
                                        wheel={false}
                                        clickWhenDrag={true}
                                    >
                                        {data}
                                    </ScrollMenu>
                                    {/*</div>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`container`}>
                        <p className={`guarantee-title`}>
                            Проба
                        </p>
                        <div className={`guarantee-proba`}>
                            <div className={`guarantee-proba__wrapper`}>
                                <div className={`guarantee-proba__image`}>
                                    <picture>
                                        <source type={`image/webp`}
                                                srcSet={`/storage/img/quality-guarantee/proba.webp`}
                                        />
                                        <img src={`/storage/img/quality-guarantee/proba.png`}
                                             alt={`proba`}
                                             title={`proba`}
                                             loading={`lazy`}
                                        />
                                    </picture>
                                </div>
                                <div className={`guarantee-proba__content`}>
                                    <p className={`guarantee-proba__text`}>
                                        Ювелирные украшения из драгоценных металлов, произведенные под ювелирным
                                        брендом PLATINA, проходят Государственный контроль в Верхне-Волжском
                                        межрегиональном
                                        управлении Федеральной пробирной палаты,
                                        после которого <span className={`bold`}>на изделие наносится оттиск
                                    Государственного пробирного клейма, являющийся гарантией соответствия
                                    пробы. </span>
                                    </p>
                                </div>
                            </div>
                            <div className={`guarantee-namesake__list`}>
                                <p className={`guarantee-namesake__text`}>
                                    В клейме зашифровано:
                                </p>
                                <p>&nbsp;</p>
                                <div className={`item`}>
                                    <div className={`circle`}>1</div>
                                    <p className={`text`}>
                                        шифр межрегионального управления Федеральной пробирной палаты
                                    </p>
                                </div>
                                <div className={`item`}>
                                    <div className={`circle`}>2</div>
                                    <p className={`text`}>
                                        знак пробирного удостоверения
                                    </p>
                                </div>
                                <div className={`item`}>
                                    <div className={`circle`}>3</div>
                                    <p className={`text`}>
                                        цифровое обозначение пробы драгоценного металла
                                    </p>
                                </div>
                            </div>
                            <p className={`guarantee-uin__text`}>
                                Обращаем ваше внимание, что согласно пункту 2 статьи 12.1
                                Федерального закона от 26.03.1998 №41-ФЗ «О драгоценных металлах и драгоценных
                                камнях» с 23 июня 2020 года опробование ювелирных изделий из серебра носит
                                добровольный характер.
                            </p>
                        </div>
                    </div>
                    <div className={`guarantee__bgColorGray`}>
                        <div className={`container`}>
                            <p className={`guarantee-title`}>
                                Нормативные документы
                            </p>
                            <div className={`guarantee-docs`}>
                                {isMobile()
                                    ? <div className={`guarantee-docs__wrapper`}>
                                        <p className={`guarantee-docs__text`}>
                                            Основными нормативными документами, регулирующими производство
                                            ювелирных
                                            изделий в Российской Федерации, являются:
                                        </p>
                                        <div className={`guarantee-docs__image`}>
                                            <picture>
                                                <source type={`image/webp`}
                                                        srcSet={`/storage/img/quality-guarantee/docs.webp`}
                                                />
                                                <img src={`/storage/img/quality-guarantee/docs.png`}
                                                     alt={`docs`}
                                                     title={`docs`}
                                                     loading={`lazy`}
                                                />
                                            </picture>
                                        </div>
                                        <div className={`guarantee-docs__list`}>
                                            <div className={`item`}>
                                                <div className={`circle`}>1</div>
                                                <p className={`text`}>
                                                    Отраслевой стандарт ОСТ 117-3-002-95 &laquo;Изделия ювелирные
                                                    из&nbsp;драгоценных металлов. Общие технические условия&raquo;
                                                </p>
                                            </div>
                                            <div className={`item`}>
                                                <div className={`circle`}>2</div>
                                                <p className={`text`}>
                                                    Технические условия ТУ&nbsp;117-4.2099-2002 &laquo;Бриллианты.
                                                    Технические требования. Классификация&raquo;.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    : <div className={`guarantee-docs__wrapper`}>
                                        <div className={`guarantee-docs__image`}>
                                            <picture>
                                                <source type={`image/webp`}
                                                        srcSet={`/storage/img/quality-guarantee/docs.webp`}
                                                />
                                                <img src={`/storage/img/quality-guarantee/docs.png`}
                                                     alt={`docs`}
                                                     title={`docs`}
                                                     loading={`lazy`}
                                                />
                                            </picture>
                                        </div>
                                        <div className={`guarantee-docs__list`}>
                                            <p className={`guarantee-docs__text`}>
                                                Основными нормативными документами, регулирующими производство
                                                ювелирных
                                                изделий в Российской Федерации, являются:
                                            </p>
                                            <p>&nbsp;</p>
                                            <div className={`item`}>
                                                <div className={`circle`}>1</div>
                                                <p className={`text`}>
                                                    Отраслевой стандарт ОСТ 117-3-002-95 &laquo;Изделия ювелирные
                                                    из&nbsp;драгоценных металлов. Общие технические условия&raquo;
                                                </p>
                                            </div>
                                            <div className={`item`}>
                                                <div className={`circle`}>2</div>
                                                <p className={`text`}>
                                                    Технические условия ТУ&nbsp;117-4.2099-2002 &laquo;Бриллианты.
                                                    Технические требования. Классификация&raquo;.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <p className={`guarantee-docs__text`}>
                                    В них даются четкие указания, каким характеристикам и стандартам должны
                                    соответствовать украшения из драгоценных металлов и бриллианты, закрепленные в
                                    них.
                                    Именно на эти документы опирается отдел технического контроля бренда PLATINA при
                                    проверке продукции на каждом этапе производства. В них же обозначено, какие
                                    реквизиты украшения и завода-изготовителя должны быть указаны на ярлыке (бирке).
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={`container`}>
                        <p className={`guarantee-title`}>
                            Бирка
                        </p>
                        <div className={`guarantee-birka`}>
                            <div className={`guarantee-birka__content`}>
                                <p className={`guarantee-birka__text`}>
                                    Еще одной защитой от подделки является фирменный двусторонний ярлык
                                    (бирка), который крепится к каждому украшению ювелирного бренда PLATINA.
                                    Ярлык изготавливается из прочного полимерного материала и несет в себе
                                    следующую информацию: кроме обязательных реквизитов (наименования
                                    изделия, артикул, наименование и проба драгоценного металла и прочих),
                                    нанесен индивидуальный код и зашифрованный в нем УИН, зарегистрированный
                                    в ГИИС ДМДК.
                                </p>
                                <p className={`guarantee-birka__text`}>
                                    Во избежание корректировок на ярлыке заполнение полей
                                    производится только машинным способом. Украшения комплектуются ярлыками
                                    согласно Постановлению Правительства РФ №270 от 26.02.2021 г.
                                </p>
                            </div>
                            <div className={`guarantee-birka__image`}>
                                <p className={`guarantee-titleSlider`}>Варианты используемых бирок:</p>
                                <QualityGuaranteeSlider />
                            </div>
                        </div>
                        <div className={`guarantee-bottomText`}>
                            <p>
                                Полное соответствие действующему законодательству - основополагающий принцип нашей
                                работы. Нам&nbsp;важно&nbsp;ваше&nbsp;доверие!
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </BaseLayout>
    }
}


// Данные для таблицы, не хочу создавать класс в хранилище ради одной таблицы
const chips = [
    {year: '2005', text: 'двпь'},
    {year: '2006', text: 'евпь'},
    {year: '2007', text: 'звпь'},
    {year: '2008', text: 'ивпь'},
    {year: '2009', text: 'квпь'},
    {year: '2010', text: 'лвпь'},
    {year: '2011', text: 'мвпь'},
    {year: '2012', text: 'нвпь'},
    {year: '2013', text: 'овпь'},
    {year: '2014', text: 'пвпь'},
    {year: '2015', text: 'рвпь'},
    {year: '2016', text: 'свпь'},
    {year: '2017', text: 'твпь'},
    {year: '2018', text: 'увпь'},
    {year: '2019', text: 'фвпь'},
    {year: '2020', text: 'хвпь'},
    {year: '2021', text: 'чвпь'},
    {year: '2022', text: 'швпь'},
    {year: '2023', text: 'ЭВПЬ'},
    {year: '2024', text: 'ЮВПЬ'},
    {year: '2025', text: 'ЯВПЬ'},
    {year: '2026', text: 'ЦВПЬ'},
].reverse().map((n, i) => ({...n, id: i + 1}));

export default useWithStore(GualityQuarantee);

